export default __webpack_public_path__ + "static/media/chevron-right.7102b14e.svg";